import "./form.scss";
import React, {useContext, useEffect, useState} from "react";
import {toast} from "react-toastify";
import {PrimaryButton} from "../button";
import {Link, useNavigate} from "react-router-dom";
import useApi from "../../hooks/useApi";
import {DEFAULT_ERROR, VERIFY_INVITE_URL} from "../../api/urls";
import {Alert} from "react-bootstrap";
import AuthContext from "../../context/AuthProvider";
import {useParams} from "react-router";
import { AdditionalFormModal } from "../../pages/Channels/AdditionalFormModal";

export const InviteFormBusiness = () => {
    const { user, isLoggedIn, userUpdate } = useContext(AuthContext);
    const api = useApi();
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    const [errorMsg, setErrorMsg] = useState(null);
    const [pendingInvite, setPendingInvite] = useState(null);
    const {id} = useParams();

    useEffect(() => {
        if (!isLoggedIn) {
            navigate(`/login?invite=${id}`, {replace: true});
        } else {
            handleSubmit();
        }
    }, []);

    const completeJoin = (response) => {
        toast.success(response.data.success || "You joined the channel!");
        const serverUser = response.data.user || {};
        const joined = response.data.channel || response.data.subscribed;
        const existing = Array.isArray(user.channels) ? user.channels : [];
        const merged = joined
            ? [...existing.filter((c) => (c.id || c._id) !== (joined.id || joined._id)), joined]
            : existing;
        userUpdate({ ...user, ...serverUser, channels: merged });
        navigate("/", { replace: true });
    };

    async function handleSubmit() {
        try {
            setIsLoading(true);
            const response = await api.post(VERIFY_INVITE_URL, { inviteCode: id });
            completeJoin(response);
        } catch (error) {
            if (error?.response?.status === 422 && error.response.data?.required_fields) {
                setPendingInvite({ requiredFields: error.response.data.required_fields });
            } else {
                const msg = error?.response?.data?.error || DEFAULT_ERROR;
                toast.error(msg);
                setErrorMsg(msg);
            }
            setIsLoading(false);
        }
    }

    const handleAdditionalSubmit = async (extraFields) => {
        const response = await api.post(VERIFY_INVITE_URL, {
            inviteCode: id,
            additional_info: extraFields,
        });
        completeJoin(response);
    };

    return (
        <>
            {pendingInvite && (
                <AdditionalFormModal
                    requiredFields={pendingInvite.requiredFields}
                    onSubmit={handleAdditionalSubmit}
                    onClose={() => navigate("/", { replace: true })}
                />
            )}
            <form className="form-container" action="">
                <>
                    <Alert show={!!errorMsg} variant="danger">
                        <p>{errorMsg}</p>
                    </Alert>
                    {!!errorMsg && (
                        <PrimaryButton to={"/login"} className="formButtonActive formbutton">
                            Back to Login
                        </PrimaryButton>
                    )}
                </>
                {!errorMsg && !pendingInvite && (
                    <>
                        <h6 className="form-heading">Joining Channel</h6>
                        <PrimaryButton
                            isLoadingMsg="Joining channel, please wait..."
                            size="sm"
                            className="formButtonActive formbutton"
                            isLoading={isLoading}
                        >
                            ""
                        </PrimaryButton>
                        <center>
                            <p style={{fontSize: "12px"}}>
                                <Link className="link2" to={"/login"}>
                                    Return to login
                                </Link>
                            </p>
                        </center>
                    </>
                )}
            </form>
        </>
    );
}
